// extracted by mini-css-extract-plugin
export default {"container":"NftInfoCard_container__yrbIx","right":"NftInfoCard_right__WNTyg"};